import React from 'react'
import FlaveCodeEditor from 'src/shared/flave_code_editor'

export default function backend_permissionInlineHtml({ value, onDataChanged, props }) {
    return <div>
        <hr />
        <h5 className="hotspot-setting-header">Raw HTML</h5>
        <div className="hotspot-setting-info">
            Enter html below to display it.
        </div>
        <div className="form-group">
            <FlaveCodeEditor value={value} placeholder="<h1 .../>" onChange={onDataChanged} />
            {/*
            <textarea
                rows={20}
                className="form-control"
                placeholder="<div .../>"
                value={value}
                onChange={onDataChanged}
            />*/}
        </div>

        
        
    </div>
}
